import React, { useState } from 'react'
import { Inertia } from '@inertiajs/inertia'
import { usePage } from '@inertiajs/inertia-react'
import Layout from '../../Shared/Layout/LayoutAdmin'
import Row from 'react-bootstrap/Row'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import AlertDismissible from '../../Shared/Components/AlertDismissible'
import Breadcrumbs from '../../Shared/Components/Breadcrumbs'
import PaginationList from '../../Shared/Components/PaginationList'
import PersonSearch from '../Sia/ProspectLog/PersonSearch'

const List = ({ items, users, filters, coverage }) => {
    const { flash } = usePage().props
    const [userId, setUserId] = useState(filters.user_id || '')
    const [from, setFrom] = useState(filters.from || '')
    const [to, setTo] = useState(filters.to || '')
    const [pageText, setPageText] = useState(filters.page_text || '')

    function search(event) {
        event.preventDefault()
        Inertia.get(route('user-visits'), {
            user_id: userId,
            from,
            to,
            page_text: pageText,
        }, { preserveState: true, preserveScroll: true })
    }

    const coverageText = coverage?.from
        ? `Los datos van del ${coverage.from} al ${coverage.to}. Se conservan los últimos 3 meses.`
        : 'Se conservan los últimos 3 meses.'

    return (
        <Row>
            <style>{`
                .log-rows tbody tr:nth-child(even) td { background: #f4f7fb; }
                .log-rows tbody tr:hover td { background: #e4eaf2; }
            `}</style>
            {flash.success && <AlertDismissible message={flash.success} type="success" />}
            <div className="card card-flush">
                <div className="card-header pt-7">
                    <h3 className="card-title align-items-start flex-column">
                        <span className="card-label fw-bold text-gray-800">Bitácora</span>
                        <span className="text-muted mt-1 fw-semibold fs-7">{coverageText}</span>
                    </h3>
                </div>
                <div className="card-body pt-6">
                    <Form onSubmit={search} className="d-flex flex-wrap gap-3 align-items-end mb-6">
                        <div style={{ minWidth: 240 }}>
                            <label className="form-label fs-7 fw-bold text-gray-600 mb-2">Usuario</label>
                            <PersonSearch
                                options={users}
                                value={userId}
                                placeholder="Todos los usuarios"
                                onChange={setUserId}
                            />
                        </div>
                        <div>
                            <label className="form-label fs-7 fw-bold text-gray-600 mb-2">Desde</label>
                            <Form.Control type="date" value={from} onChange={(event) => setFrom(event.target.value)} />
                        </div>
                        <div>
                            <label className="form-label fs-7 fw-bold text-gray-600 mb-2">Hasta</label>
                            <Form.Control type="date" value={to} onChange={(event) => setTo(event.target.value)} />
                        </div>
                        <div style={{ minWidth: 220 }}>
                            <label className="form-label fs-7 fw-bold text-gray-600 mb-2">Página</label>
                            <Form.Control
                                value={pageText}
                                placeholder="Texto de la página"
                                onChange={(event) => setPageText(event.target.value)}
                            />
                        </div>
                        <Button type="submit" size="sm">Buscar</Button>
                    </Form>
                    <div className="table-responsive">
                        <table className="table table-row-dashed align-middle gs-0 gy-3 my-0 log-rows">
                            <thead>
                                <tr className="fs-7 fw-bold text-gray-500 border-bottom-0">
                                    <th>Usuario</th>
                                    <th>Fecha</th>
                                    <th>Página</th>
                                    <th>IP</th>
                                    <th>Navegador</th>
                                </tr>
                            </thead>
                            <tbody>
                                {items.data.length === 0 && (
                                    <tr>
                                        <td colSpan="5" className="text-center text-muted py-6">No hay datos.</td>
                                    </tr>
                                )}
                                {items.data.map((item) => (
                                    <tr key={item.id}>
                                        <td className="fw-semibold">{item.user_name}</td>
                                        <td className="text-nowrap">{item.created_at}</td>
                                        <td style={{ wordBreak: 'break-all' }}>{item.url}</td>
                                        <td className="text-nowrap">{item.ip_address}</td>
                                        <td style={{ maxWidth: 280 }} className="text-muted">
                                            <span className="d-inline-block text-truncate w-100" title={item.user_agent}>{item.user_agent}</span>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <PaginationList links={items.links} />
                </div>
            </div>
        </Row>
    )
}

List.layout = (page) => <Layout children={page} title="Bitácora" />

export default List
